import React, { Component } from 'react';
import './App.css';
import { Switch, Route, Redirect } from 'react-router-dom';
import Portfolio from './components/Portfolio';
// import Routes from './main/Routes';


class App extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/" component={Portfolio} />
        <Redirect exact from="*" to="/" />
        {/*
          <Redirect exact from="*" to="/" />
        
        */}
      </Switch>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js